/**
 * Navigation-only German overrides. "Creator Help Center" and
 * "Seller Help Center" are established product names and stay in English.
 */
export default {
  "Creator Help Center": "Creator Help Center",
  "Seller Help Center": "Seller Help Center",
} as Record<string, string>;
